import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { initVersionCheck } from './lib/versionCheck';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registro del Service Worker — solo en producción
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => console.info('[SW] Registered:', reg.scope))
      .catch((err) => console.error('[SW] Registration failed:', err));
  });
}

// Auto-reload cuando hay versión nueva desplegada.
// Resuelve el caso PWA mobile: Chrome restaura la tab con el bundle viejo
// en memoria, sin hacer fetch del HTML. Detectamos y forzamos reload.
// Solo activa en PROD (ver src/lib/versionCheck.js).
initVersionCheck();